import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=7d5e9509&scoped=true"
var script = {}
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=7d5e9509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5e9509",
  null
  
)

export default component.exports